import { internalFetch } from '../utils/fetchHelper';

export type OrderStatusGroupAudience = 'Client' | 'Manager' | 'Contractor';
export type StatusGroupKind = 'order';

const statusGroupEndpoint = (_kind: StatusGroupKind): string =>
  'orderStatusGroup';

const statusGroupsEndpoint = (_kind: StatusGroupKind): string =>
  'orderStatusGroups';

const withApiKey = (pathWithQuery: string): string => {
  const apiKey = import.meta.env.VITE_BACKEND_API_KEY;
  if (!apiKey || apiKey === 'undefined') {
    return pathWithQuery;
  }
  const separator = pathWithQuery.includes('?') ? '&' : '?';
  return `${pathWithQuery}${separator}code=${encodeURIComponent(apiKey)}`;
};

export interface IOrderStatusGroup {
  id: number;
  statusId?: number;
  audience: OrderStatusGroupAudience;
  name: string;
  code?: string;
  color?: string;
  icon?: string;
  showInDashboardCard?: boolean | number | null;
  dashboardCardNumber?: number | null;
  isDeleted?: boolean | null;
}

export interface ICreateOrderStatusGroupRequest {
  statusId: number;
  audience: OrderStatusGroupAudience;
  name: string;
  code?: string;
  color?: string;
  icon?: string;
  showInDashboardCard?: boolean | number | null;
  dashboardCardNumber?: number | null;
}

export interface ICreateOrderStatusGroupResponse {
  orderStatusGroupId: number;
  isSuccess: boolean;
  message: string | null;
  correlationId?: string;
}

export interface IUpdateOrderStatusGroupRequest {
  statusId: number;
  audience: OrderStatusGroupAudience;
  name: string;
  code?: string;
  color?: string;
  icon?: string;
  showInDashboardCard?: boolean | number | null;
  dashboardCardNumber?: number | null;
  isDeleted: boolean;
}

export const getOrderStatusGroups = async (
  abortController: AbortController,
  audience: OrderStatusGroupAudience,
  kind: StatusGroupKind = 'order'
): Promise<IOrderStatusGroup[]> => {
  return internalFetch(
    withApiKey(
      `${import.meta.env.VITE_BACKEND_API_URL}/p/${statusGroupsEndpoint(
        kind
      )}?audience=${encodeURIComponent(audience)}`
    ),
    'GET',
    abortController
  );
};

export const createOrderStatusGroup = async (
  abortController: AbortController,
  item: ICreateOrderStatusGroupRequest,
  kind: StatusGroupKind = 'order'
): Promise<ICreateOrderStatusGroupResponse> => {
  return internalFetch(
    withApiKey(
      `${import.meta.env.VITE_BACKEND_API_URL}/p/${statusGroupEndpoint(kind)}`
    ),
    'POST',
    abortController,
    JSON.stringify(item)
  );
};

export const updateOrderStatusGroup = async (
  abortController: AbortController,
  orderStatusGroupId: number,
  item: IUpdateOrderStatusGroupRequest,
  kind: StatusGroupKind = 'order'
): Promise<number> => {
  return internalFetch(
    withApiKey(
      `${import.meta.env.VITE_BACKEND_API_URL}/p/${statusGroupEndpoint(
        kind
      )}?orderStatusGroupId=${orderStatusGroupId}`
    ),
    'PUT',
    abortController,
    JSON.stringify(item)
  );
};

export const deleteOrderStatusGroup = async (
  abortController: AbortController,
  orderStatusGroupId: number,
  kind: StatusGroupKind = 'order'
): Promise<number> => {
  return internalFetch(
    withApiKey(
      `${import.meta.env.VITE_BACKEND_API_URL}/p/${statusGroupEndpoint(
        kind
      )}?orderStatusGroupId=${orderStatusGroupId}`
    ),
    'DELETE',
    abortController
  );
};
